import {
  fetchGiveaways,
  fetchBalance,
  fetchPayments,
  getDailyRewards,
} from '@/api';

import useGiveawaysStore from '@/store/ShortGiveawaysStore';
import useBalanceStore from '@/store/BalanceStore';
import { usePreload } from '@/hooks/usePreload';
import usePaymentsStore from '@/store/PaymentsStore';
import { useDailyRewardStore } from '@/store/DailyRewardStore';

const PreloadCheck = () => {
  const setGiveaways = useGiveawaysStore((state) => state.setGiveaways);
  const setBalance = useBalanceStore((state) => state.setBalance);
  const setPayments = usePaymentsStore((state) => state.setPayments);
  const setDailyRewards = useDailyRewardStore((state) => state.setDailyRewards);

  usePreload([
    {
      key: 'giveaways',
      queryFn: () => fetchGiveaways(),
      onSuccess: (data) => {
        if (data && data.length > 0) {
          setGiveaways(data);
        }
      },
    },
    // {
    //   key: 'login',
    //   queryFn: () => fetchLogin(),
    //   onSuccess: (data) => {
    //   },
    // },
    {
      key: 'balance',
      queryFn: () => fetchBalance(),
      onSuccess: (data) => {
        if (data) {
          setBalance(data);
        }
      },
    },
    {
      key: 'payments',
      queryFn: () => fetchPayments(),
      onSuccess: (data) => {
        if (data) {
          setPayments(data);
          console.log(data, 'payments');
        }
      },
    },
    {
      key: 'dailyRewards',
      queryFn: () => getDailyRewards(),
      onSuccess: (data) => {
        if (data) {
          console.log(data, 'dailyRewards');
          setDailyRewards(data);
        }
      },
    },
  ]);

  return null;
};

export default PreloadCheck;
